import { mainSiteUrl } from '@/mocks/categories';

const ctaBgImage = "https://readdy.ai/api/search-image?query=Warm%20atmospheric%20lifestyle%20scene%20with%20fashion%20accessories%20and%20textile%20textures%20artfully%20arranged%20on%20rustic%20wooden%20surface%20soft%20golden%20hour%20backlight%20creating%20warm%20glow%20shallow%20depth%20of%20field%20editorial%20aesthetic%20dreamy%20soft%20focus%20elegant%20sophisticated%20composition%20warm%20amber%20and%20sand%20tones%20refined%20modern%20feel&width=1400&height=900&seq=cta-bg-v3&orientation=landscape";

export default function CTASection() {
  return (
    <section className="relative bg-background-50 overflow-hidden">
      <div className="flex flex-col lg:flex-row">
        <div className="relative flex-1 min-h-[320px] md:min-h-[400px] lg:min-h-[500px] overflow-hidden">
          <img
            src={ctaBgImage}
            alt="CSSBuy Spreadsheet atmosphere"
            className="absolute inset-0 w-full h-full object-cover object-top"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-foreground-900/15"></div>
          <div className="absolute bottom-8 md:bottom-12 left-6 md:left-12">
            <p className="text-white/75 text-xs md:text-sm font-medium uppercase tracking-[0.2em] mb-2">
              Acesse a planilha completa
            </p>
            <h2 className="font-heading text-white text-2xl md:text-4xl lg:text-5xl font-bold leading-tight">
              CSSBuy
              <br />
              Spreadsheet
              <br />
              <span className="italic font-light">Sheet</span>
            </h2>
          </div>
        </div>

        <div className="flex-1 flex items-center justify-center p-10 md:p-16 lg:p-20 bg-background-50">
          <div className="max-w-md text-center">
            <h2 className="font-heading text-foreground-900 text-2xl md:text-4xl font-black leading-tight mb-6">
              Comece Hoje
              <br />
              <span className="italic font-light">Agora Mesmo</span>
            </h2>
            <p className="text-foreground-500 text-sm md:text-base leading-relaxed mb-8">
              Não perca tempo com métodos manuais e agents caros. O CSSBuy Spreadsheet oferece o método mais eficiente de compra internacional. Acesse agora e comece a importar com inteligência.
            </p>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-full bg-foreground-900 text-background-50 text-sm md:text-base font-semibold hover:bg-foreground-800 transition-all duration-300 whitespace-nowrap cursor-pointer group"
            >
              <span>Buy It Now</span>
              <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform duration-300"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}